import React, { ReactNode } from 'react';
import { Col, theme as antTheme } from 'antd';

import BlockHeaderLabel from '@totem/components/ui_components/headers/BlockHeaderLabel';
import BlockHeaderValue from '@totem/components/ui_components/headers/BlockHeaderValue';

type Props = {
  title: ReactNode;
  value: ReactNode;
  titleStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
  span: number;
};

const BlockHeaderItem = ({
  span,
  title,
  value,
  titleStyle,
  valueStyle,
}: Props) => {
  const { token } = antTheme.useToken();

  const cellStyle: React.CSSProperties = {
    backgroundColor: token.colorFillAlter,
    borderColor: token.colorBgContainer,
    borderStyle: 'solid',
    borderWidth: 4,
  };

  return (
    <Col span={span} style={cellStyle}>
      <BlockHeaderLabel style={titleStyle}>{title}</BlockHeaderLabel>
      <BlockHeaderValue style={valueStyle}>{value}</BlockHeaderValue>
    </Col>
  );
};

export default BlockHeaderItem;
